import { Table } from "react-bootstrap";
import { getPrograma } from "../../index";
import Fila from "./Fila";
import { getParticipantes } from "../../../../Context/Participante";

export default function Encuesta() {
    const p = getPrograma();
    const l = getParticipantes();
    const i = p.encuesta.filter(e => l.some(p => p.id === e.participante));
    return <Table>
        <thead>
            <tr>
                <th>NOMBRE</th>
                <th>CORREO</th>
                <th>TELEFONO</th>
                <th>RESPUESTA</th>
            </tr>
        </thead>
        <tbody>
            {i.map(e => <Fila encuesta={e} />)}
        </tbody>
    </Table>
}